'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _add = require('./icons/add.svg');

var _add2 = _interopRequireDefault(_add);

var _addBold = require('./icons/add-bold.svg');

var _addBold2 = _interopRequireDefault(_addBold);

var _administrativeArea = require('./icons/administrative-area.svg');

var _administrativeArea2 = _interopRequireDefault(_administrativeArea);

var _arrow = require('./icons/arrow.svg');

var _arrow2 = _interopRequireDefault(_arrow);

var _alert = require('./icons/alert.svg');

var _alert2 = _interopRequireDefault(_alert);

var _barChart = require('./icons/bar-chart.svg');

var _barChart2 = _interopRequireDefault(_barChart);

var _bestMobileAward = require('./icons/best-mobile-award.svg');

var _bestMobileAward2 = _interopRequireDefault(_bestMobileAward);

var _bestFixed = require('./icons/best-fixed.svg');

var _bestFixed2 = _interopRequireDefault(_bestFixed);

var _g = require('./icons/5g.svg');

var _g2 = _interopRequireDefault(_g);

var _browser = require('./icons/browser.svg');

var _browser2 = _interopRequireDefault(_browser);

var _calendar = require('./icons/calendar.svg');

var _calendar2 = _interopRequireDefault(_calendar);

var _caret = require('./icons/caret.svg');

var _caret2 = _interopRequireDefault(_caret);

var _cellTowers = require('./icons/cellTowers.svg');

var _cellTowers2 = _interopRequireDefault(_cellTowers);

var _checkCircle = require('./icons/checkCircle.svg');

var _checkCircle2 = _interopRequireDefault(_checkCircle);

var _check = require('./icons/check.svg');

var _check2 = _interopRequireDefault(_check);

var _chevron = require('./icons/chevron.svg');

var _chevron2 = _interopRequireDefault(_chevron);

var _chip = require('./icons/chip.svg');

var _chip2 = _interopRequireDefault(_chip);

var _chipManufacturer = require('./icons/chip-manufacturer.svg');

var _chipManufacturer2 = _interopRequireDefault(_chipManufacturer);

var _city = require('./icons/city.svg');

var _city2 = _interopRequireDefault(_city);

var _clearAll = require('./icons/clearAll.svg');

var _clearAll2 = _interopRequireDefault(_clearAll);

var _close = require('./icons/close.svg');

var _close2 = _interopRequireDefault(_close);

var _cloudDown = require('./icons/cloudDown.svg');

var _cloudDown2 = _interopRequireDefault(_cloudDown);

var _cloudUp = require('./icons/cloudUp.svg');

var _cloudUp2 = _interopRequireDefault(_cloudUp);

var _cma = require('./icons/cma.svg');

var _cma2 = _interopRequireDefault(_cma);

var _code = require('./icons/code.svg');

var _code2 = _interopRequireDefault(_code);

var _combined = require('./icons/combined.svg');

var _combined2 = _interopRequireDefault(_combined);

var _company = require('./icons/company.svg');

var _company2 = _interopRequireDefault(_company);

var _controller = require('./icons/controller.svg');

var _controller2 = _interopRequireDefault(_controller);

var _country = require('./icons/country.svg');

var _country2 = _interopRequireDefault(_country);

var _coverage = require('./icons/coverage.svg');

var _coverage2 = _interopRequireDefault(_coverage);

var _createGroup = require('./icons/create-group.svg');

var _createGroup2 = _interopRequireDefault(_createGroup);

var _customGroups = require('./icons/custom-groups.svg');

var _customGroups2 = _interopRequireDefault(_customGroups);

var _customization = require('./icons/customization.svg');

var _customization2 = _interopRequireDefault(_customization);

var _delete = require('./icons/delete.svg');

var _delete2 = _interopRequireDefault(_delete);

var _desktop = require('./icons/desktop.svg');

var _desktop2 = _interopRequireDefault(_desktop);

var _duplicate = require('./icons/duplicate.svg');

var _duplicate2 = _interopRequireDefault(_duplicate);

var _deviceManufacturer = require('./icons/device-manufacturer.svg');

var _deviceManufacturer2 = _interopRequireDefault(_deviceManufacturer);

var _display = require('./icons/display.svg');

var _display2 = _interopRequireDefault(_display);

var _download = require('./icons/download.svg');

var _download2 = _interopRequireDefault(_download);

var _dualMaps = require('./icons/dualMaps.svg');

var _dualMaps2 = _interopRequireDefault(_dualMaps);

var _edit = require('./icons/edit.svg');

var _edit2 = _interopRequireDefault(_edit);

var _edit3 = require('./icons/edit2.svg');

var _edit4 = _interopRequireDefault(_edit3);

var _edit5 = require('./icons/edit3.svg');

var _edit6 = _interopRequireDefault(_edit5);

var _editBold = require('./icons/edit-bold.svg');

var _editBold2 = _interopRequireDefault(_editBold);

var _expand = require('./icons/expand.svg');

var _expand2 = _interopRequireDefault(_expand);

var _eye = require('./icons/eye.svg');

var _eye2 = _interopRequireDefault(_eye);

var _exportData = require('./icons/exportData.svg');

var _exportData2 = _interopRequireDefault(_exportData);

var _facebook = require('./icons/facebook.svg');

var _facebook2 = _interopRequireDefault(_facebook);

var _feedback = require('./icons/feedback.svg');

var _feedback2 = _interopRequireDefault(_feedback);

var _filter = require('./icons/filter.svg');

var _filter2 = _interopRequireDefault(_filter);

var _gauge = require('./icons/gauge.svg');

var _gauge2 = _interopRequireDefault(_gauge);

var _gear = require('./icons/gear.svg');

var _gear2 = _interopRequireDefault(_gear);

var _globe = require('./icons/globe.svg');

var _globe2 = _interopRequireDefault(_globe);

var _glossary = require('./icons/glossary.svg');

var _glossary2 = _interopRequireDefault(_glossary);

var _help = require('./icons/help.svg');

var _help2 = _interopRequireDefault(_help);

var _home = require('./icons/home.svg');

var _home2 = _interopRequireDefault(_home);

var _host = require('./icons/host.svg');

var _host2 = _interopRequireDefault(_host);

var _horizontalStackedChart = require('./icons/horizontalStackedChart.svg');

var _horizontalStackedChart2 = _interopRequireDefault(_horizontalStackedChart);

var _info = require('./icons/info.svg');

var _info2 = _interopRequireDefault(_info);

var _isp = require('./icons/isp.svg');

var _isp2 = _interopRequireDefault(_isp);

var _internet = require('./icons/internet.svg');

var _internet2 = _interopRequireDefault(_internet);

var _jitter = require('./icons/jitter.svg');

var _jitter2 = _interopRequireDefault(_jitter);

var _lineChart = require('./icons/line-chart.svg');

var _lineChart2 = _interopRequireDefault(_lineChart);

var _list = require('./icons/list.svg');

var _list2 = _interopRequireDefault(_list);

var _locality = require('./icons/locality.svg');

var _locality2 = _interopRequireDefault(_locality);

var _location = require('./icons/location.svg');

var _location2 = _interopRequireDefault(_location);

var _locationMap = require('./icons/location-map.svg');

var _locationMap2 = _interopRequireDefault(_locationMap);

var _lock = require('./icons/lock.svg');

var _lock2 = _interopRequireDefault(_lock);

var _lockOpen = require('./icons/lockOpen.svg');

var _lockOpen2 = _interopRequireDefault(_lockOpen);

var _loss = require('./icons/loss.svg');

var _loss2 = _interopRequireDefault(_loss);

var _mail = require('./icons/mail.svg');

var _mail2 = _interopRequireDefault(_mail);

var _menu = require('./icons/menu.svg');

var _menu2 = _interopRequireDefault(_menu);

var _makeACopy = require('./icons/make-a-copy.svg');

var _makeACopy2 = _interopRequireDefault(_makeACopy);

var _map = require('./icons/map.svg');

var _map2 = _interopRequireDefault(_map);

var _mailOpen = require('./icons/mailOpen.svg');

var _mailOpen2 = _interopRequireDefault(_mailOpen);

var _maintenance = require('./icons/maintenance.svg');

var _maintenance2 = _interopRequireDefault(_maintenance);

var _methodology = require('./icons/methodology.svg');

var _methodology2 = _interopRequireDefault(_methodology);

var _mobile = require('./icons/mobile.svg');

var _mobile2 = _interopRequireDefault(_mobile);

var _more = require('./icons/more.svg');

var _more2 = _interopRequireDefault(_more);

var _mosaicGrid = require('./icons/mosaic-grid.svg');

var _mosaicGrid2 = _interopRequireDefault(_mosaicGrid);

var _multiple = require('./icons/multiple.svg');

var _multiple2 = _interopRequireDefault(_multiple);

var _multiple3 = require('./icons/multiple2.svg');

var _multiple4 = _interopRequireDefault(_multiple3);

var _myGroups = require('./icons/my-groups.svg');

var _myGroups2 = _interopRequireDefault(_myGroups);

var _neighborhood = require('./icons/neighborhood.svg');

var _neighborhood2 = _interopRequireDefault(_neighborhood);

var _networkPrivate = require('./icons/networkPrivate.svg');

var _networkPrivate2 = _interopRequireDefault(_networkPrivate);

var _networkPublic = require('./icons/networkPublic.svg');

var _networkPublic2 = _interopRequireDefault(_networkPublic);

var _newStatic = require('./icons/new-static.svg');

var _newStatic2 = _interopRequireDefault(_newStatic);

var _overview = require('./icons/overview.svg');

var _overview2 = _interopRequireDefault(_overview);

var _packet = require('./icons/packet.svg');

var _packet2 = _interopRequireDefault(_packet);

var _pc = require('./icons/pc.svg');

var _pc2 = _interopRequireDefault(_pc);

var _pin = require('./icons/pin.svg');

var _pin2 = _interopRequireDefault(_pin);

var _ping = require('./icons/ping.svg');

var _ping2 = _interopRequireDefault(_ping);

var _play = require('./icons/play.svg');

var _play2 = _interopRequireDefault(_play);

var _postalCode = require('./icons/postal-code.svg');

var _postalCode2 = _interopRequireDefault(_postalCode);

var _ranking = require('./icons/ranking.svg');

var _ranking2 = _interopRequireDefault(_ranking);

var _radioDot = require('./icons/radio-dot.svg');

var _radioDot2 = _interopRequireDefault(_radioDot);

var _satellite = require('./icons/satellite.svg');

var _satellite2 = _interopRequireDefault(_satellite);

var _satellite3 = require('./icons/satellite2.svg');

var _satellite4 = _interopRequireDefault(_satellite3);

var _save = require('./icons/save.svg');

var _save2 = _interopRequireDefault(_save);

var _save3 = require('./icons/save2.svg');

var _save4 = _interopRequireDefault(_save3);

var _saveAs = require('./icons/saveAs.svg');

var _saveAs2 = _interopRequireDefault(_saveAs);

var _search = require('./icons/search.svg');

var _search2 = _interopRequireDefault(_search);

var _settings = require('./icons/settings.svg');

var _settings2 = _interopRequireDefault(_settings);

var _selection = require('./icons/selection.svg');

var _selection2 = _interopRequireDefault(_selection);

var _server = require('./icons/server.svg');

var _server2 = _interopRequireDefault(_server);

var _schedule = require('./icons/schedule.svg');

var _schedule2 = _interopRequireDefault(_schedule);

var _share = require('./icons/share.svg');

var _share2 = _interopRequireDefault(_share);

var _share3 = require('./icons/share2.svg');

var _share4 = _interopRequireDefault(_share3);

var _sharedGroups = require('./icons/shared-groups.svg');

var _sharedGroups2 = _interopRequireDefault(_sharedGroups);

var _signal = require('./icons/signal.svg');

var _signal2 = _interopRequireDefault(_signal);

var _single = require('./icons/single.svg');

var _single2 = _interopRequireDefault(_single);

var _singleList = require('./icons/single-list.svg');

var _singleList2 = _interopRequireDefault(_singleList);

var _star = require('./icons/star.svg');

var _star2 = _interopRequireDefault(_star);

var _starEmpty = require('./icons/starEmpty.svg');

var _starEmpty2 = _interopRequireDefault(_starEmpty);

var _status = require('./icons/status.svg');

var _status2 = _interopRequireDefault(_status);

var _subscription = require('./icons/subscription.svg');

var _subscription2 = _interopRequireDefault(_subscription);

var _reload = require('./icons/reload.svg');

var _reload2 = _interopRequireDefault(_reload);

var _tablet = require('./icons/tablet.svg');

var _tablet2 = _interopRequireDefault(_tablet);

var _table = require('./icons/table.svg');

var _table2 = _interopRequireDefault(_table);

var _topRatedCell = require('./icons/top-rated-cell.svg');

var _topRatedCell2 = _interopRequireDefault(_topRatedCell);

var _topRatedFixed = require('./icons/top-rated-fixed.svg');

var _topRatedFixed2 = _interopRequireDefault(_topRatedFixed);

var _trash = require('./icons/trash.svg');

var _trash2 = _interopRequireDefault(_trash);

var _trash3 = require('./icons/trash2.svg');

var _trash4 = _interopRequireDefault(_trash3);

var _twitter = require('./icons/twitter.svg');

var _twitter2 = _interopRequireDefault(_twitter);

var _unview = require('./icons/unview.svg');

var _unview2 = _interopRequireDefault(_unview);

var _upgrade = require('./icons/upgrade.svg');

var _upgrade2 = _interopRequireDefault(_upgrade);

var _upload = require('./icons/upload.svg');

var _upload2 = _interopRequireDefault(_upload);

var _user = require('./icons/user.svg');

var _user2 = _interopRequireDefault(_user);

var _users = require('./icons/users.svg');

var _users2 = _interopRequireDefault(_users);

var _verticalBarChart = require('./icons/vertical-bar-chart.svg');

var _verticalBarChart2 = _interopRequireDefault(_verticalBarChart);

var _video = require('./icons/video.svg');

var _video2 = _interopRequireDefault(_video);

var _view = require('./icons/view.svg');

var _view2 = _interopRequireDefault(_view);

var _wifi = require('./icons/wifi.svg');

var _wifi2 = _interopRequireDefault(_wifi);

var _video5gMobile = require('./icons/video5gMobile.svg');

var _video5gMobile2 = _interopRequireDefault(_video5gMobile);

var _videoFixed = require('./icons/videoFixed.svg');

var _videoFixed2 = _interopRequireDefault(_videoFixed);

var _videoMobile = require('./icons/videoMobile.svg');

var _videoMobile2 = _interopRequireDefault(_videoMobile);

var _best5gGamingExperience = require('./icons/best5gGamingExperience.svg');

var _best5gGamingExperience2 = _interopRequireDefault(_best5gGamingExperience);

var _bestMobileGamingExperience = require('./icons/bestMobileGamingExperience.svg');

var _bestMobileGamingExperience2 = _interopRequireDefault(_bestMobileGamingExperience);

var _bestIspGamingExperience = require('./icons/bestIspGamingExperience.svg');

var _bestIspGamingExperience2 = _interopRequireDefault(_bestIspGamingExperience);

var _gCoverage = require('./icons/5gCoverage.svg');

var _gCoverage2 = _interopRequireDefault(_gCoverage);

function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    default: obj
  };
} // Icon Imports


exports.default = {
  fiveG: _g2.default,
  fiveGCoverage: _gCoverage2.default,
  add: _add2.default,
  addBold: _addBold2.default,
  administrativeArea: _administrativeArea2.default,
  arrow: _arrow2.default,
  alert: _alert2.default,
  barChart: _barChart2.default,
  bestMobileAward: _bestMobileAward2.default,
  browser: _browser2.default,
  calendar: _calendar2.default,
  caret: _caret2.default,
  cellTowers: _cellTowers2.default,
  checkCircle: _checkCircle2.default,
  check: _check2.default,
  chevron: _chevron2.default,
  chip: _chip2.default,
  chipsetManufacturer: _chipManufacturer2.default,
  city: _city2.default,
  clearAll: _clearAll2.default,
  close: _close2.default,
  cloudDown: _cloudDown2.default,
  cloudUp: _cloudUp2.default,
  cma: _cma2.default,
  code: _code2.default,
  combined: _combined2.default,
  company: _company2.default,
  controller: _controller2.default,
  country: _country2.default,
  coverage: _coverage2.default,
  createGroup: _createGroup2.default,
  customGroups: _customGroups2.default,
  customization: _customization2.default,
  deleteIcon: _delete2.default,
  desktop: _desktop2.default,
  duplicate: _duplicate2.default,
  deviceManufacturer: _deviceManufacturer2.default,
  display: _display2.default,
  download: _download2.default,
  dualMaps: _dualMaps2.default,
  eye: _eye2.default,
  edit: _edit2.default,
  edit2: _edit4.default,
  edit3: _edit6.default,
  editBold: _editBold2.default,
  expand: _expand2.default,
  exportData: _exportData2.default,
  facebook: _facebook2.default,
  feedback: _feedback2.default,
  filter: _filter2.default,
  gauge: _gauge2.default,
  gear: _gear2.default,
  globe: _globe2.default,
  glossary: _glossary2.default,
  help: _help2.default,
  home: _home2.default,
  host: _host2.default,
  horizontalStackedChart: _horizontalStackedChart2.default,
  info: _info2.default,
  internet: _internet2.default,
  isp: _isp2.default,
  jitter: _jitter2.default,
  lineChart: _lineChart2.default,
  list: _list2.default,
  locality: _locality2.default,
  location: _location2.default,
  locationMap: _locationMap2.default,
  lock: _lock2.default,
  lockOpen: _lockOpen2.default,
  loss: _loss2.default,
  mail: _mail2.default,
  menu: _menu2.default,
  makeACopy: _makeACopy2.default,
  map: _map2.default,
  mailOpen: _mailOpen2.default,
  maintenance: _maintenance2.default,
  methodology: _methodology2.default,
  mobile: _mobile2.default,
  more: _more2.default,
  mosaicGrid: _mosaicGrid2.default,
  multiple: _multiple2.default,
  multiple2: _multiple4.default,
  myGroups: _myGroups2.default,
  neighborhood: _neighborhood2.default,
  networkPrivate: _networkPrivate2.default,
  networkPublic: _networkPublic2.default,
  newStatic: _newStatic2.default,
  overview: _overview2.default,
  packet: _packet2.default,
  pc: _pc2.default,
  pin: _pin2.default,
  ping: _ping2.default,
  play: _play2.default,
  postalCode: _postalCode2.default,
  ranking: _ranking2.default,
  radioDot: _radioDot2.default,
  satellite: _satellite2.default,
  satellite2: _satellite4.default,
  save: _save2.default,
  save2: _save4.default,
  saveAs: _saveAs2.default,
  search: _search2.default,
  settings: _settings2.default,
  selection: _selection2.default,
  server: _server2.default,
  schedule: _schedule2.default,
  share: _share2.default,
  share2: _share4.default,
  sharedGroups: _sharedGroups2.default,
  signal: _signal2.default,
  single: _single2.default,
  singleList: _singleList2.default,
  star: _star2.default,
  starEmpty: _starEmpty2.default,
  status: _status2.default,
  subscription: _subscription2.default,
  reload: _reload2.default,
  table: _table2.default,
  tablet: _tablet2.default,
  topRatedCell: _topRatedCell2.default,
  topRatedFixed: _topRatedFixed2.default,
  trash: _trash2.default,
  trash2: _trash4.default,
  twitter: _twitter2.default,
  unview: _unview2.default,
  upgrade: _upgrade2.default,
  upload: _upload2.default,
  user: _user2.default,
  users: _users2.default,
  video: _video2.default,
  verticalBarChart: _verticalBarChart2.default,
  video5gMobile: _video5gMobile2.default,
  videoFixed: _videoFixed2.default,
  videoMobile: _videoMobile2.default,
  best5gGamingExperience: _best5gGamingExperience2.default,
  bestMobileGamingExperience: _bestMobileGamingExperience2.default,
  bestIspGamingExperience: _bestIspGamingExperience2.default,
  view: _view2.default,
  wifi: _wifi2.default,
  bestFixed: _bestFixed2.default
};